import { Dispatch } from "redux"
import { ApiConfig } from "../../../../../config"
import { AppStateWithData } from "../../../../AppStateWithData"
import { createRequestActionTypes } from "../../../../../utils/request-actions-helpers/createRequestActionTypes"
import { RequestThunkParameters, createRequestThunk } from "../../../../../utils/request-actions-helpers/createRequestThunk"
import { fetchHiddenDocuments } from "../../../documents/actions"

export interface DeleteCommentAdditionalData {
    docId: string
    commentId: string
}

export const deleteCommentActionTypes = createRequestActionTypes('DELETE_COMMENT')

export const deleteComment = (config: ApiConfig) => (docId: string, commentId: string) =>
    async (dispatch: Dispatch, getState: () => AppStateWithData) => {
        const thunkParams: RequestThunkParameters<any, never, DeleteCommentAdditionalData> = {
            url: `${config.API_URL}/comments?id=${commentId}`,
            method: 'DELETE',
            requestActionTypes: deleteCommentActionTypes,
            actionAdditionalData: {
                commentId,
                docId
            },
        processResultBeforeDispatch: (requestResult: any) => {
                if(docId) {
                    dispatch<any>(fetchHiddenDocuments(config)([docId]))
                }
                return requestResult
            }
        }
        return dispatch<any>(createRequestThunk(thunkParams))
    }